const responseCodes = {
  // For Login service response
  accountTypeDenied: 'loginauthenticateaccountypedenied',
  invalidCredential: 'loginauthenticatepasswordmismatch',

  // I don't this this error code comes up anymore. Replaced by simply "user.not-found"?
  loginUserNotFound: 'loginauthenticateusernot-found',

  userNotExist: 'usernot-found',
  maxAttempt: 'loginauthenticatepasswordmismatchmax-attempts',
  onlineAccessDenied: 'accessdenied',
  invalidUserID: 'userInfouserId',

  // New login error codes that don't remove the "." to simplify code

  /**
   * user id not found or user id and password didn't match
   */
  userNotFound: 'user.not-found',

  /**
   * One more attempt remaining alert. Account will be locked after one more
   * failed login attempt.
   */
  oneMoreAttempt: 'login.authenticate.password.mismatch.max-attempts',

  /**
   * Failed Iovation device validation - insecure device.
   */
  deviceValidationDenyError: 'device.validation.deny.error',

  /**
   * Access disabled. User must call support
   */
  accessUnavailable: 'access.denied',

  /**
   * Account logged by too many failed attempts.
   */
  accountLocked: 'login.authenticate.user.locked',

  /**
   * Not new. Applies to login. Was categorized under linked accounts before. This error may apply to both.
   */
  passwordMismatch: 'login.authenticate.password.mismatch',

  // Reset password error
  userIdMismatch: 'reset-password.verification.user-id.mismatch',
  accountNotFound: 'reset-password.verification.account.not-found',
  // Linked Accounts
  previouslyLinkedUserId: 'previously.linked.user-id',
  userNotRegistered: 'user.not-found',
  passwordUsage: 'reset-password.update.password.usage',
  // Registration
  invalidRegistration: 'registration.verification.error',
  invalidAuthCode: 'registration.invalid.authcode',
  userAlreadyRegistered: 'registration.user.already.registered',
  accessDenied: 'access.denied',
  userIdUnavailable: 'registration.userid.unavailable',
  registerAccountLocked: 'registration.account.locked',
  invalidAccount: 'registration.accountnumber.unavailable',
  paymentScheduled: 'payment-method.payment.scheduled.exists',
  paymentMethodExistsAutopay: 'payment-method.autopay.exists',
  accountMismatch: 'account.number.mismatch',
  // Session Expired
  sessionExpired: 'AccessTokenexpired',
  // Payments
  bankUnauthorized: 'payments.bank.unauthorized',
  invalidRoutingNumber: 'payments.bank.invalid-routing-number',
  paymentAlreadyExist: 'payments.already-exist',
  scheduledDateInvalid: 'payments.scheduled-date.invalid',
  invalidPaymentAmount: 'payment.amount.invalid',
  paymentAmountExceeds: 'payment.amount.current-balance.exceeds',
  accountDeliquent: 'account.deliquent',
  paymentFailed: 'payment.failed',
  bankIdMismatch: 'payment.bankId.mismatch',
  paymentMethodUnauthorized: 'payment.payment-method.unauthorized',
  invalidPaymentDate: 'payment.date.invalid',
  scheduledPaymentExists: 'payment.scheduled.exists',
  paymentMethodAlreadyExist: 'payment-method.exists',
  /**
   * Error code for enterprise payment methods endpoints
   */
  enterpriseRepaymentsBusinessError: 'enterprise.repayments.businessError',
  routingNumberInvalid: 'payment-method.routing-number.invalid',
  invalidZipCode: 'zipcode mismatching',
  sameDayPaymentExists: 'same.day.payment.exist',
  // sams
  invalidSamsAccountType: 'invalid.sams.account.type',

  /**
   * Error code from api endpoint when request uses an access token that has
   * expired.
   */
  accessTokenExpired: 'gateway.client.authenticationFailure'
}

export default responseCodes
